import fileDownload from 'js-file-download';
import moment, { Moment } from 'moment';
import { USER_SUBSCRIPTION_PLAN } from 'src/ReduxStorage/resourceNames';
import { ResourceApi } from 'src/resource/Resource';
import {
  GetPaymentTransactionsResponse,
  UserSubscriptionPlanResource,
  UserSubscriptionPlanResourceGetPaymentTransactions,
} from 'src/resource/UserSubscriptionPlanResource/types';
import {
  UserSubscriptionPlanPaymentTransactionStatus,
  UserSubscriptionStripeConnectStatus,
} from '../../../../ReduxStorage/UserSubscriptionPlans/constants';
import { ChipVariant } from '../../../components/Chip/component';
import { SelectOption } from '../../../components/Select/component';
import { Countries } from './constants';

export const getChipVariantFromStripeConnectStatus = (
  status: UserSubscriptionStripeConnectStatus
): ChipVariant => {
  switch (status) {
    case 'active':
      return 'success';
    case 'pending':
      return 'warning';
    case 'no_stripe_account':
    case 'no_revenue_share':
    case 'ol_revenue_no_stripe_account':
    default:
      return 'default';
  }
};

export const getChipVariantFromPaymentTransactionStatus = (
  status: UserSubscriptionPlanPaymentTransactionStatus
): ChipVariant => {
  switch (status) {
    case UserSubscriptionPlanPaymentTransactionStatus.PURCHASED:
      return 'success';
    case UserSubscriptionPlanPaymentTransactionStatus.REFUNDED:
      return 'error';
    default:
      return 'default';
  }
};

export const makeCountryOptions = (): SelectOption[] => {
  const emptyOption: SelectOption = {
    label: 'Please choose a country',
    value: '',
  };
  return [emptyOption].concat(
    Countries.map((country) => ({
      label: `${country.name} (${country.code})`,
      value: country.code,
    }))
  );
};

export const exportPaymentTranToCsv = async (
  subscriptionId: string,
  fromDate: Moment,
  toDate: Moment
): Promise<void> => {
  const fromTime = fromDate.startOf('day').toDate();
  const toTime = toDate.endOf('day').toDate();
  const limit = 100;
  const headers = [
    'purchase date',
    'payout date',
    'status',
    'item',
    'course path',
    'learner fullName',
    'currency',
    'settled amount',
    'amount you received',
    'revenue share',
    'stripe purchase fee',
    'stripe payout fee',
    'tax',
  ];

  let afterPaymentId = null;
  let csvData = `${headers.join('\t')}\n`;

  /* eslint-disable no-await-in-loop */
  /* eslint-disable no-constant-condition */
  while (true) {
    const [
      { results },
    ]: GetPaymentTransactionsResponse[] = await ResourceApi.read<
      UserSubscriptionPlanResource,
      UserSubscriptionPlanResourceGetPaymentTransactions
    >(USER_SUBSCRIPTION_PLAN, subscriptionId, [
      {
        method: 'getPaymentTransactions',
        args: {
          fromTime,
          toTime,
          limit,
          afterPaymentId,
        },
      },
    ]);

    if (results.length === 0) {
      break;
    }

    for (let i = 0; i < results.length; i++) {
      const payment = results[i];
      const rowItems = [
        payment.purchaseDate
          ? moment(payment.purchaseDate).format('DD/MM/YYYY')
          : '',
        payment.payoutDate
          ? moment(payment.payoutDate).format('DD/MM/YYYY')
          : '',
        payment.status,
        payment.item,
        payment.coursePath,
        payment.user.fullName,
        payment.settledCurrency,
        payment.settledAmount,
        payment.amountReceived,
        payment.revenueShare,
        payment.stripeFee,
        payment.payoutFee,
        payment.tax,
      ];

      csvData += `${rowItems.join('\t')}\n`;
    }

    afterPaymentId = results[results.length - 1].id;
  }

  fileDownload(csvData, 'transactions.csv');
};
